export const search = (obj) => {
    document.title = "Søk";
    return `
        <div class="container">
            ${obj.breadcrumbHtml}
        </div>
        <div class="container">
            <div class="row xjustify-content-md-center xcol-12 no-gutters" style="">
                <div class="searchheader">
                    <div class="container">
                        <div class="row no-gutters">
                            <h4 class="searchheader__input-title">Søk</h4>
                            <div class="searchheader__input-group">
                                <div class="header__search__container">
                                    <input type="text" class="input-control header__search__input is-active searchheader__inputfield" id="searchheader__inputfield" placeholder="${obj.inputPlaceholder}" value="">
                                    <button class="searchheader__search-button header__button__dosearch" id="searchheader__button" type="button">
                                        <span class="material-icons-outlined header__icon">&#xE8B6;</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row searchcontent no-gutters">
                    <div class="col-12 col-md-1" id="leftCol" style="display:none;">
                        <div class="categories">
                            <div class="categories__header">
                                <h2 class="categories__headertitle">
                                    <a href="#" class="categories__headerlink">${obj.filterHeader}</a>
                                </h2>
                            </div>
                            <div class="categories__selected"></div>
                            <div class="categories__list">
                                <div class="categories__collection"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-9" id="mainCol">
                        <div class="searchresult__header">
                            <div class="searchresult__meta">
                                <div class="row">
                                    <div class="col-12 col-md-8">
                                        <div id="resultscount" class="searchresult__meta__count"></div>
                                    </div>
                                    <div class="col-12 col-md-5 no-gutters">
                                        <div class="dropdown searchresult__meta__dropdown__container">
                                            <label class="searchresult__meta__label">${obj.sortByLabel}</label>
                                            <div class="searchresult__meta__dropdown">
                                                <button class="btn btn-default dropdown-toggle pull-right searchresult__meta__dropdown-button" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                                    <span class="btn-text searchresult__meta__choosedtxt">${obj.relevanseText}</span>
                                                    <span class="icon material-icons-outlined">&#xe5cf</span>
                                                </button>
                                                <ul class="dropdown-menu dropdown-menu-right searchresult__meta__dropdown-content" aria-labelledby="dropdownMenu1">
                                                    <li><a href="#" data-order="Relevance" class="searchresult__meta__choice dropdown-item">${obj.relevanseText}</a></li>
                                                    <li><a href="#" data-order="Date" class="searchresult__meta__choice dropdown-item">${obj.sortByDateText}</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="searchresult">
                            <div class="lds-ellipsis black">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                            <div class="searchresult__filter"></div>
                            <div class="">
                                <div class="searchresult__list list-unstyled"></div>
                            </div>
                            <div class="searchresult__footer">
                                <div class="searchresult__pagination"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
}